"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ToggleCard = require("./ToggleCard.styles");
var _excluded = ["pressed", "defaultPressed", "onClick"];
/**
 * Toggle cards are an official
 * [WAI-ARIA button](https://www.w3.org/TR/wai-aria-practices/#button) type that use the
 * [aria-pressed](https://www.w3.org/TR/wai-aria-1.1/#aria-pressed) attribute to tell assistive
 * technologies that the card can be toggled like a button.
 *
 * **Important:** it is critical that content of the card
 * does not change when its state changes.
 *
 * @extends Card
 * @since 8.34.0
 */
var ToggleCard = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var pressed = _ref.pressed,
    defaultPressed = _ref.defaultPressed,
    onClick = _ref.onClick,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(defaultPressed),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    pressedState = _useState2[0],
    setPressedState = _useState2[1];
  var onClickCallback = (0, _react.useCallback)(function (e) {
    setPressedState(!pressedState);
    if (onClick) {
      // for controlled components, we pass the current value of pressed
      //   (the toggling behavior is controlled by external logic)
      // for uncontrolled components, we pass the opposite of pressedState
      //   (because this component is where the toggling logic happens)
      onClick(e, typeof pressed !== 'undefined' ? pressed : !pressedState);
    }
  }, [onClick, pressed, pressedState]);

  // If pressed is defined, use that value as a controlled value, otherwise use local
  // uncontrolled state.
  var ariaPressed = pressedState;
  if (typeof pressed !== 'undefined') {
    ariaPressed = pressed;
  }
  return /*#__PURE__*/_react.default.createElement(_ToggleCard.StyledToggleCard, (0, _extends2.default)({
    "aria-pressed": !!ariaPressed,
    onClick: onClickCallback,
    role: "button",
    interactive: true,
    ref: forwardedRef
  }, rest));
});
exports.ToggleCard = ToggleCard;
ToggleCard.displayName = 'ToggleCard';
ToggleCard.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Sets the [aria-pressed](https://www.w3.org/TR/wai-aria-1.1/#aria-pressed) state and use as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   *
   * A toggle card can use `pressed` or `defaultPressed`, but not both.
   */
  defaultPressed: _propTypes.default.bool,
  /**
   * A click handler that will be called with two arguments, `e`, the button click event,
   * and `pressed`, the current pressed state.
   */
  onClick: _propTypes.default.func,
  /**
   * Sets the [aria-pressed](https://www.w3.org/TR/wai-aria-1.1/#aria-pressed) state and use as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   *
   * A toggle card can use `pressed` or `defaultPressed`, but not both.
   */
  pressed: _propTypes.default.bool
} : {};
ToggleCard.defaultProps = {
  defaultPressed: undefined,
  onClick: undefined,
  pressed: undefined
};